/**
 * Created by Ivan on 03.06.2025
 */

RewardsConfig.LightingRushWelcomeBonus = {
    energy: 25
};

RewardsConfig.LightningRush = [
    {
        units: [
            { code: "ff", stage: 5 },
            { code: "f", stage: 4 },
            { code: "dd", stage: 1 },
            { code: "qq", stage: 2 },
            { code: "cc", stage: 1 }
        ],
        stickers2GreenPack: 1
    }
];
